// src/utils/znacznikSesji.js — jedno ciasteczko, jedna informacja: „ktoś jest zalogowany”.
//
// PO CO: strona główna (fleetify.pl) jest statyczna i stoi na INNYM adresie niż
// panel (partner.fleetify.pl), więc sesji Firebase nie widzi — dane logowania
// żyją w magazynie konkretnego origin. Żeby pasek na stronie mógł pokazać
// „Przejdź do panelu” zamiast „Zaloguj się”, panel zostawia ciasteczko na
// domenie NADRZĘDNEJ (.fleetify.pl), które oba adresy widzą.
//
// CO W NIM JEST: wyłącznie „1”. Żadnego tokenu, identyfikatora ani adresu e-mail:
// ciasteczko jest czytelne dla JavaScriptu na stronie, więc nie może nieść niczego,
// czego nie chcielibyśmy tam zobaczyć. To podpowiedź dla interfejsu, nie dowód
// tożsamości — wejście do panelu i tak sprawdza token po stronie serwera.

const NAZWA = 'fleetify_sesja';
const DNI = 30;

// Domenę wyliczamy z adresu, a nie wpisujemy na sztywno: na localhost i na
// *.web.app ciasteczko z domeną .fleetify.pl zostałoby odrzucone przez przeglądarkę
// i znacznik nie działałby wcale (a błędu też by nie było).
function domena() {
    const host = window.location.hostname;
    if (host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) return null;
    const czesci = host.split('.');
    if (czesci.length < 2) return null;
    return '.' + czesci.slice(-2).join('.');
}

export function oznaczSesje(zalogowany) {
    try {
        const d = domena();
        const wspolne = `path=/;samesite=lax${window.location.protocol === 'https:' ? ';secure' : ''}${d ? `;domain=${d}` : ''}`;
        if (zalogowany) {
            document.cookie = `${NAZWA}=1;max-age=${DNI * 86400};${wspolne}`;
        } else {
            document.cookie = `${NAZWA}=;max-age=0;${wspolne}`;
        }
    } catch (e) {
        // Ciasteczka zablokowane: strona główna pokaże po prostu „Zaloguj się”.
    }
}

export default oznaczSesje;
